module.exports = __webpack_public_path__ + "static/media/PM10.c57fec21.mp4";